(function () {
  'use strict';

  var PALETTE = ['#D81E34', '#FBFAF7', '#3DA0E3', '#BBE3F4', '#FFE9B0'];
  var CONFETTI_COUNT = 16;

  function spawnConfetti(host) {
    if (!host || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    host.innerHTML = '';

    for (var i = 0; i < CONFETTI_COUNT; i++) {
      var piece = document.createElement('span');
      var width = 5 + Math.round(Math.random() * 4);
      var height = 9 + Math.round(Math.random() * 8);
      var duration = (2.6 + Math.random() * 2.2).toFixed(2);
      var delay = (Math.random() * 4).toFixed(2);

      piece.style.cssText =
        'left:' +
        Math.round(Math.random() * 100) +
        '%;width:' +
        width +
        'px;height:' +
        height +
        'px;background:' +
        PALETTE[i % PALETTE.length] +
        ';animation-duration:' +
        duration +
        's;animation-delay:' +
        delay +
        's;';

      host.appendChild(piece);
    }
  }

  function initJuly4HeroEffects() {
    document.querySelectorAll('[data-july4-confetti]').forEach(spawnConfetti);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJuly4HeroEffects);
  } else {
    initJuly4HeroEffects();
  }
})();
